export function readCookie(name) {
    return document.cookie.replace(new RegExp(`(?:(?:^|.*;\\s*)${name}\\s*\\=\\s*([^;]*).*$)|^.*$`), "$1");
}

export function setCookie(name, value, options) {
    let newCookie = `${name}=${value}`;

    const { expireSeconds, sameSite } = options;

    if (expireSeconds) {
        newCookie += `; expires=` + new Date(Date.now() + expireSeconds * 1000);
    }

    if (sameSite) {
        newCookie += `; SameSite=${sameSite}`;
    }

    newCookie += `; path=/`;

    document.cookie = newCookie;
}
